'use client';

import ImageComponent from "@/components/ui/ImageComponent"
import { GoArrowRight } from "react-icons/go";
import Link from "next/link";
import { usePathname } from "next/navigation";

const isExternalHref = (url: string) =>
    url.startsWith("http://") || url.startsWith("https://");

interface LaserHairCardProps {
    slug: string,
    data_image: string,
    alt_name: string,
    heading_text: string,
    description_text: string
}

const LaserHairPackageCard = ({ data_image, alt_name, heading_text, description_text, slug }: LaserHairCardProps) => {

    const pathname = usePathname();
    const isStatic = slug === '_static-treatment';
    const href = isStatic
        ? undefined
        : slug
            ? isExternalHref(slug)
                ? slug
                : `${pathname.replace(/\/$/, '')}/${slug}`
            : '/';
    const openInNewTab = Boolean(href && isExternalHref(href));

    const content = (
        <div className="rounded-3xl border-[1px] border-lightSliver p-3 mx-2 h-fit md:h-full flex flex-col justify-between gap-4">
            <div className="space-y-6 h-auto">
                {data_image ? <div className="mx-auto h-auto w-full rounded-2xl overflow-hidden">
                    <ImageComponent url={data_image || "/images/home_data/google_logo.svg"} img_title={alt_name || "Hair_packge"} object_cover={false} />
                </div> : <></>}
                <div className={`space-y-2.5 flex flex-col justify-start  overflow-hidden text-ellipsis`}>
                    <h3 className="text-lightBrown font-semibold text-lg/[28px] text-start line-clamp-2">{heading_text}</h3>
                    <p className={`text-textf1 text-sm/[25.6px] text-start`}>
                        {description_text}
                    </p>
                </div>
            </div>
            <div>
                {isStatic ? <span className="mb-1"></span> : <div className="group flex text-silverBlue font-semibold text-base items-center gap-1 cursor-pointer hover:opacity-90 mb-1">
                    <span>View details</span>
                    <span className="transition-transform duration-200 group-hover:translate-x-1">
                        <GoArrowRight className="font-bold" />
                    </span>
                </div>}
            </div>
        </div>
    );

    return isStatic ? content : (
        <Link
            href={href ?? '#'}
            className="h-full"
            {...(openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        >
            {content}
        </Link>
    );
}

export default LaserHairPackageCard